export const objectIdToDate = function(value) {
  return new Date(parseInt(value.substring(0, 8), 16) * 1000);
};

const wrapRefresh = async call => {
  const result = await call();
  if (!result.ok) {
    const msg = (await result.clone().json()).message;
    console.log(msg);
    if (msg === "Invalid credentials") {
      const token = localStorage.getItem("hil_token");
      if (token != null) {
        await localStorage.removeItem("hil_token");
        window.location.href = "/";
      }
    }
    if (msg === "Expired token") {
      const headers = new Headers();
      const token = localStorage.getItem("hil_token");
      if (token != null) {
        headers.append("Authorization", token);
      }
      const resp = await fetch(`${process.env.VUE_APP_BASEURL}/refresh`, {
        method: "POST",
        headers
      });
      if (!resp.ok) {
        await localStorage.removeItem("hil_token");
        window.location.href = "/";
      }
      const newToken = (await resp.json()).token;
      await localStorage.setItem("hil_token", newToken);
      return await call();
    }
  }
  return result;
};

export const fetchHil = (url, options) => {
  const headers = headers || new Headers();
  const token = localStorage.getItem("hil_token");
  if (token != null) {
    headers.append("Authorization", token);
  }
  if (
    options &&
    typeof options.body === "object" &&
    !(options.body instanceof FormData)
  ) {
    headers.append("Content-Type", "application/json");
    options.body = JSON.stringify(options.body);
  }

  return wrapRefresh(() =>
    fetch(process.env.VUE_APP_BASEURL + url, {
      ...options,
      headers
    })
  );
};

export const fetchHil2 = async (method, url, options) => {
  const headers = headers || new Headers();
  const token = localStorage.getItem("hil_token");
  if (token != null) {
    headers.append("Authorization", token);
  }
  if (
    options &&
    typeof options.body === "object" &&
    !(options.body instanceof FormData)
  ) {
    headers.append("Content-Type", "application/json");
    options.body = JSON.stringify(options.body);
  }

  const resp = await wrapRefresh(() =>
    fetch(process.env.VUE_APP_BASEURL + url, {
      ...options,
      headers,
      method
    })
  );

  return await resp.json();
};
